<template>
  <div id="page-toolbar-container">
    <b-row>
      <template v-if="selectedProducts.length">
        <b-col lg="2" class="mb-3 mb-lg-0">
          <b-button
            id="delete-selected-btn"
            variant="outline-primary"
            class="btn btn-block w-100 mb-3"
            @click="deleteMultipleProducts('delete_multiple_products')"
            :disabled="loading"
          >
            <span> Delete Selected ({{ countSelectedProduct }}) </span>
          </b-button>
        </b-col>
      </template>
      <b-col md="12" lg="3" class="mb-3 mb-lg-0">
        <div class="filter-wrapper bg-white rounded">
          <b-input-group prepend>
            <span class="px-1 d-inline-flex align-items-center">
              <img src="@/assets/images/search.svg" alt="Search Products" />
            </span>
            <b-form-input
              placeholder="Search"
              v-model="keyword"
              @input="setParam"
            >
            </b-form-input>
            <b-dropdown text="Advanced" variant="primary" slot="append">
              <b-dropdown-item
                v-for="(option, index) in advance_search_options"
                :key="'advance_option_' + index"
                @click="selectAdvanceOption(index)"
              >
                {{ option }}
                <i class="ml-1" v-if="selected_advance_option === index">
                  <img
                    width="15"
                    height="15"
                    src="@/assets/images/checked-symbol.svg"
                    alt=""
                    class="mr-1"
                  />
                </i>
              </b-dropdown-item>
            </b-dropdown>
          </b-input-group>
        </div>
      </b-col>
      <b-col md="12" lg="6">
        <b-row>
          <b-col md="6" class="mb-3 mb-lg-0">
            <div class="d-flex">
              <b-button-group
                class="upload-button action-button p-0 overflow-hidden"
                @click="loading ? null : $refs.inputSimple.click()"
              >
                <b-button
                  variant="ghost"
                  class="bg-white py-1 px-2 d-inline-flex align-items-center flex-grow-0"
                >
                  <img src="@/assets/images/excel-icon.png" alt="Excel" />
                </b-button>
                <b-button
                  variant="ghost"
                  class="bg-white py-1 px-2 text-dark border-left flex-grow-1 text-left"
                >
                  <small class="font-weight-bold">
                    {{
                      loading && uploadProductType === "simple"
                        ? "Uploading..."
                        : "Upload Simple Product"
                    }}
                  </small>
                </b-button>
                <input
                  type="file"
                  @change="importSimple"
                  accept=".zip"
                  v-show="false"
                  id="importSimple"
                  ref="inputSimple"
                />
              </b-button-group>
              <a
                href="https://s3.ap-southeast-1.amazonaws.com/drr.cms.rush.ph/import/ProductSimple.zip"
                class="download-button mx-2 mt-1"
              >
                <img
                  class="action-button"
                  src="@/assets/images/download-icon.png"
                  alt="Download"
                />
              </a>
            </div>
          </b-col>
          <b-col md="6" class="mb-3 mb-lg-0">
            <div class="d-flex">
              <b-button-group
                class="upload-button action-button p-0 overflow-hidden"
                @click="loading ? null : $refs.inputVariable.click()"
              >
                <b-button
                  variant="ghost"
                  class="bg-white py-1 px-2 d-inline-flex align-items-center flex-grow-0"
                >
                  <img src="@/assets/images/excel-icon.png" alt="Excel" />
                </b-button>
                <b-button
                  variant="ghost"
                  class="bg-white py-1 px-2 text-dark border-left flex-grow-1 text-left"
                >
                  <small class="font-weight-bold">
                    {{
                      loading && uploadProductType === "variable"
                        ? "Uploading..."
                        : "Upload Variable Product"
                    }}
                  </small>
                </b-button>
                <input
                  type="file"
                  @change="importVariable"
                  accept=".zip"
                  v-show="false"
                  id="importVariable"
                  ref="inputVariable"
                />
              </b-button-group>
              <a
                href="https://s3.ap-southeast-1.amazonaws.com/drr.cms.rush.ph/import/ProductVariable.zip"
                class="download-button mx-2 mt-1 action"
              >
                <img
                  class="action-button"
                  src="@/assets/images/download-icon.png"
                  alt="Excel"
                />
              </a>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col lg="2">
        <b-button
          block
          variant="primary"
          class="d-inline-block new-button align-top pl-2"
          @click="$router.push({ name: 'CreateProduct' })"
          id="add-new-product-btn"
        >
          <span style="font-size: 8pt">+ Add New Product</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import notification from "@/services/notification";

export default {
  name: "InventoryPageToolbar",
  data() {
    return {
      category: {
        selected: "all",
        options: [],
        initial_category: {
          value: "all",
          text: "All Categories",
        },
      },
      advance_search_options: [],
      selected_advance_option: "all",
      keyword: "",
      uploadProductType: null,
      zipMimeTypes: [
        "application/zip",
        "application/zip-compressed",
        "application/x-zip",
        "application/x-zip-compressed",
        "application/octet-stream",
      ],
      merchant_uuid: "",
      selectedProducts: [],
      countSelectedProduct: 0,
    };
  },
  mounted() {
    this.hideDeleteSelectedButton();
    this.selectedProducts = this.modal.delete_multiple_products.product_ids;
  },
  created: function () {
    this.getCategories();
    this.getAdvanceSearch();
  },
  computed: {
    ...mapState("estoreInventories", [
      "categories",
      "advance_search",
      "param",
      "loading",
      "modal",
      "pagination",
      "errors",
    ]),
    ...mapState("analytics", ["isSegmentAnalyticsReady"]),
  },
  methods: {
    ...mapActions("estoreInventories", [
      "importSimpleProduct",
      "importVariableProduct",
    ]),
    async getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]);
        reader.onerror = () => reject(new Error("Something went wrong"));
      });
    },
    async importSimple(e) {
      const file = e.target.files[0];

      if (this.zipMimeTypes.includes(file.type)) {
        const base64File = await this.getBase64(file);

        if (base64File) {
          this.uploadProductType = "simple";

          await this.importSimpleProduct({ zip: base64File });

          if (!this.errors && this.isSegmentAnalyticsReady) {
            window.analytics.track("Import E-Store Simple Products", {
              file_name: file.name,
            });
          }

          this.$refs.inputSimple.value = null;
          this.uploadProductType = null;
        }
      } else notification.warning("Format invalid.");
    },
    async importVariable(e) {
      const file = e.target.files[0];

      if (this.zipMimeTypes.includes(file.type)) {
        const base64File = await this.getBase64(file);

        if (base64File) {
          this.uploadProductType = "variable";

          await this.importVariableProduct({ zip: base64File });

          if (!this.errors && this.isSegmentAnalyticsReady) {
            window.analytics.track("Import E-Store Variable Products", {
              file_name: file.name,
            });
          }

          this.$refs.inputVariable.value = null;
          this.uploadProductType = null;
        }
      } else notification.warning("Format invalid.");
    },

    getCategories: async function () {
      this.category.options = [];
      await this.$store.dispatch("estoreInventories/getCategories").then(() => {
        this.category.options.push(this.category.initial_category);

        this.categories.map((category) => {
          this.category.options.push({
            value: category.id,
            text: category.name,
          });
        });
      });
    },

    getAdvanceSearch: async function () {
      await this.$store
        .dispatch("estoreInventories/getAdvanceSearch")
        .then(() => {
          this.advance_search_options = this.advance_search;
        });
    },

    selectAdvanceOption: function (value) {
      this.selected_advance_option = value;
      this.setParam();
    },

    setParam: function () {
      let param = {
        page: this.param.page,
        payload: {
          filters: {
            paired_key: this.category.selected,
            keyword: this.keyword,
            column: this.selected_advance_option,
          },
        },
      };
      this.$store.commit("estoreInventories/setParam", param);
    },

    deleteMultipleProducts: function (type) {
      this.$store.commit("estoreInventories/setModal", {
        type: type,
        product_ids: this.modal.delete_multiple_products.product_ids,
        merchant_uuid: this.modal.delete_multiple_products.merchant_uuid,
        status: true,
        has_tagged_products:
          this.modal.delete_multiple_products.has_tagged_products,
      });
    },
    hideDeleteSelectedButton: function () {
      this.modal.delete_multiple_products.product_ids = [];
    },
  },
  watch: {
    "modal.delete_multiple_products.product_ids": function (newValue) {
      this.selectedProducts = newValue;
      if (newValue.length) {
        this.countSelectedProduct = newValue.length;
      } else {
        this.countSelectedProduct = 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-button {
  background: white;
  width: 100%;
  font-size: 13px;
  font-family: MainFontBold, sans-serif;
  font-weight: normal;
  padding: 9px;
  border-radius: 50px;
  img {
    padding: 0 10px;
  }
}
</style>
